import React from "react";
import { Button, Box, Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Tooltip } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import moment from "moment";


const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#3FA7D6",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#3FA7D6",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "lightblue",
      },
      "&:hover fieldset": {
        borderColor: "#3FA7D6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3FA7D6",
      },
    },
  },
})(TextField);

const BasicDets = (props) => {
  const { customerList, empList, payerList, programs } = props;

  let selCust = [];
  let pSponsor = [];
  let pManager = [];
  let pCustomer = customerList.map((cust, indx) => {
    return {
      value: !props.edit ? cust.id : cust.cus_id,
      title: !props.edit ? cust.customer_name : cust.cus_name,
    };
  });
  let pPayers = payerList.map((p) => { return { value: p?.payerDets?.payer_id, title: p?.payerDets?.payer_name }; })

  if (props.edit) {
    selCust.push(customerList[0].cus_is_company);
    pSponsor.push({
      value: customerList[0].cus_id,
      title: customerList[0].cus_name,
    });
    pManager = !props.proj_employees
      ? []
      : props.proj_employees
        .filter(
          (emp) =>
            emp.emp_is_active === true
        )
        .map((emp, indx) => {
          return {
            value: emp.emp_id,
            title: emp.emp_first_name + " " + emp.emp_last_name,
          };
        });
  } else {
    selCust = customerList
      .filter(({ id }) => id === +props.formVals.pCustomer)
      .map((cus) => {
        return cus.cus_is_company;
      });
    pSponsor = customerList
      .filter(({ id }) => id === +props.formVals.pCustomer)
      .map((cust, indx) => {
        return { value: cust.id, title: cust.customer_name };
      });
    pManager = empList
      .filter((emp) => emp.emp_type === "Manager" || emp.emp_type === "Admin")
      .map((emp, indx) => {
        return { value: emp.id, title: emp.employee_name };
      });
  }

  pSponsor = [{ value: "No Sponsor", title: "No Sponsor" }, ...pSponsor];

  return (
    <div>
      <CssTextField
        className={props.edit ? ` my-2 w-100` : ` my-2 w-100`}
        label="PROJECT TITLE"
        value={props.formVals.pTitle}
        onChange={props.handlebasicDetailsChange}
        variant="outlined"
        id="pTitle"
        required
        inputProps={{ maxLength: 100 }}
      />
      <CssTextField
        className={props.edit ? ` my-2 w-100` : ` my-2 w-100`}
        label="PROJECT DESCRIPTION"
        value={props.formVals.pDesc}
        onChange={props.handlebasicDetailsChange}
        variant="outlined"
        id="pDesc"
        required
        inputProps={{ maxLength: 250 }}
      />
      <CssTextField
        className={props.edit ? ` my-2 w-100` : ` my-2 w-100`}
        label="PROJECT ACTIVE PLAN VERSION"
        value={props.formVals.active_plan_version || ""}
        onChange={props.handlebasicDetailsChange}
        variant="outlined"
        id="active_plan_version"
        required
        inputProps={{ maxLength: 20 }}
      />
      <Autocomplete
        id="pro_program_id"
        value={
          programs.find(program =>
            String(program.program_id) === String(props.formVals.pro_program_id)
          ) || null
        }
        className="my-2 w-100"
        onChange={(event, newValue) => {
          props.handlebasicDetailsChange({
            target: {
              id: "pro_program_id",
              value: newValue ? newValue.program_id : "",
            },
          });
        }}
        options={programs}
        getOptionLabel={(option) =>
          option.program_name || `Program #${option.program_id}`
        }
        isOptionEqualToValue={(option, value) =>
          String(option.program_id) === String(value.program_id)
        }
        renderInput={(params) => (
          <CssTextField {...params} label="PROGRAM" variant="outlined" />
        )}
      />
      <Autocomplete
        id="pCustomer"defaultValue={props.customer_id}
        value={pCustomer.find((type) => type.value === props.formVals.pCustomer)}
        className={props.edit ? ` my-2 w-100` : ` my-2 w-100`}
        onChange={(event, newValue) => {
          console.log(newValue)
          let val = pCustomer.find((man) => man.title === newValue.title);
          props.handlebasicDetailsChange({
            target: { id: "pCustomer", value: !!val ? val.value : "" },
          });
        }}
        options={pCustomer}
        getOptionLabel={(option) => option.title}
        renderInput={(params) => (
          <CssTextField {...params} label="CUSTOMER *" variant="outlined" />
        )}
        disabled={props.edit}
      />
      <Autocomplete
        id="pSponsor"
        value={
          pSponsor.find((type) => type.value === props.formVals.pSponsor) ||
          null
        }
        className={props.edit ? ` my-2 w-100` : ` my-2 w-100`}
        onChange={(event, newValue) => {
          let val = pSponsor.find((man) => man.title === newValue.title);
          props.handlebasicDetailsChange({
            target: { id: "pSponsor", value: !!val ? val.value : "No Sponsor" },
          });
        }}
        options={pSponsor}
        getOptionLabel={(option) => option.title}
        renderInput={(params) => (
          <CssTextField
            {...params}
            label="PROJECT SPONSOR"
            variant="outlined"
          />
        )}
        disabled={props.edit}
      />
      <Autocomplete
        id="pManager"
        required
        value={
          pManager.find((type) => type.value === props.formVals.pManager) ||
          null
        }
        className={props.edit ? ` my-2 w-100` : ` my-2 w-100`}
        onChange={(event, newValue) => {
          let val = pManager.find((man) => man.title === newValue.title);
          props.handlebasicDetailsChange({
            target: { id: "pManager", value: !!val ? val.value : "" },
          });
        }}
        options={pManager}
        getOptionLabel={(option) => option.title}
        renderInput={(params) => (
          <CssTextField
            {...params}
            label="PROJECT MANAGER *"
            variant="outlined"
          />
        )}
      />
      <FormControl component="fieldset" className="my-2 w-100">
        <FormLabel component="legend">SELF PAY?</FormLabel>
        <RadioGroup
          name="pSelfPay"
          value={props.formVals.pSelfPay}
          onChange={(e) => {
            props.handlebasicDetailsChange({
              target: { id: "pSelfPay", value: e.target.value === "true" },
            });
          }}
          row
          sx={{ gap: 2, mt: 1 }}
        >
          <FormControlLabel
            value={true}
            control={<Radio />}
            label="Yes"
          />
          <FormControlLabel
            value={false}
            control={<Radio />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
      <div className={`w-100  my-2`} style={{ display: 'flex', gap: '10px' }}>
        <Autocomplete
          style={{ flex: 1 }}
          id="pPrimaryPayer"
          value={
            pPayers.find((payer) => payer.value === props.formVals.pPrimaryPayer) ||
            null
          }
          className={props.edit ? `my-2 ` : `my-2 `}
          onChange={(event, newValue) => {
            props.handlebasicDetailsChange({
              target: { id: "pPrimaryPayer", value: newValue.value },
            });
          }}
          options={pPayers}
          getOptionLabel={(option) => option.title}
          renderInput={(params) => (
            <CssTextField
              {...params}
              label="PRIMARY PAYER"
              variant="outlined"
            />
          )}
        />

        <Autocomplete
          style={{ flex: 1 }}
          id="pSecondaryPayer"
          value={
            pPayers.find((payer) => payer.value === props.formVals.pSecondaryPayer) ||
            null
          }
          className={props.edit ? `my-2 ` : ` my-2`}
          onChange={(event, newValue) => {
            props.handlebasicDetailsChange({
              target: { id: "pSecondaryPayer", value: newValue.value },
            });
          }}
          options={pPayers}
          getOptionLabel={(option) => option.title}
          renderInput={(params) => (
            <CssTextField
              {...params}
              label="SECONDARY PAYER"
              variant="outlined"
            />
          )}
        />
      </div>
      {['place01char', 'place02char', 'place03char'].map(field => (
        props.visibilityStatus[field] && (
          <Tooltip title={props.getFieldLabel(field, field)} placement="top">
          <CssTextField
            key={field}
            label={props.getFieldLabel(field, field)}
            id={field}
            type="text"
            value={props.formVals[field] || ''}
            onChange={props.handlebasicDetailsChange}
            required={props.isFieldRequired(field)}
            fullWidth
            className="my-2"
            error={!!props.errors?.[field]}
          />
          </Tooltip>
        )
      ))}
      {['place04date', 'place05date'].map(field => (
        props.visibilityStatus[field] && (
          <Tooltip title={props.getFieldLabel(field, field)} placement="top">
          <CssTextField
            key={field}
            label={props.getFieldLabel(field, field)}
            id={field}
            type="date"
            value={moment(props.formVals[field]?.replace(/Z/g, "")).format('YYYY-MM-DD') || ''}
            onChange={props.handlebasicDetailsChange}
            required={props.isFieldRequired(field)}
            fullWidth
            className="my-2"
            InputLabelProps={{ shrink: true }}
            error={!!props.errors?.[field]}
          />
          </Tooltip>
        )
      ))}
      {['place06number', 'place07number'].map(field => (
        props.visibilityStatus[field] && (
          <Tooltip title={props.getFieldLabel(field, field)} placement="top">
          <CssTextField
            key={field}
            label={props.getFieldLabel(field, field)}
            id={field}
            type="number"
            value={props.formVals[field] || ''}
            onChange={props.handlebasicDetailsChange}
            required={props.isFieldRequired(field)}
            fullWidth
            className="my-2"
            error={!!props.errors?.[field]}
          />
          </Tooltip>
        )
      ))}
      <Button
        className={!!props.edit ? "w-100" : "w-100"}
        variant="contained"
        fullWidth
        type="button"
        onClick={() => props.onContinue("dateLocation")}
        sx={{ mt: 2 }}
      >
        Continue
      </Button>
    </div>
  );
};

export default BasicDets;
